<figure kb-overlay-figure
  [abstract]="abstract"
  [heading]="heading"
  [headingLevel]="headingLevel"
  [class.indented]="indented"
  [class.large-heading]="largeHeading"
  [headingLines]="largeHeading ? 3 : 2"
  [attr.kb-grid-item-columns]="rootColumns"
  [abstractMode]="abstractMode"
>
  <kb-video
    [src]="src"
    [poster]="poster"
    [crop]="crop"
    [autoplay]="autoplay ?? false"
    [loop]="loop ?? false"
    [controls]="(abstract || heading) ? 'minimal' : 'full'"
  />
</figure>
